import React from 'react'
import DrawerComp from 'components/Drawer'
import SelectComp from 'components/SelectComp'
import useForm from 'hooks/useForm'
import useSos from 'hooks/useSos'

type Props = {
    hookForm: ReturnType<typeof useForm<{ src_sos: string, disposition: string }>>
}

const Filters: React.FC<Props> = ({ hookForm }: Props) => {
    const hookSos = useSos({ orderBy: 'desc' });

    return (
        <DrawerComp
            title='Filtros'
            placement='right'
            type='button'
            variant='outline-primary'
        >
            {/* Estado de la llamada */}
            <SelectComp
                className='mb-4'
                title='Estado'
                name='disposition'
                value={hookForm.form?.disposition}
                options={[
                    { label: 'Todas', value: 'all' },
                    { label: 'Contestadas', value: 'ANSWERED' },
                    { label: 'No Contestadas', value: 'NO ANSWER' },
                    { label: 'Fallidas', value: 'FAILED' },
                    { label: 'Congestionadas', value: 'CONGESTION' },
                ]}
                onChange={hookForm.handleChange}
            />
            {/* Poste Origen */}
            <SelectComp
                className='mb-4'
                title='Origen'
                name='src_sos'
                value={hookForm.form?.src_sos}
                options={[
                    { label: 'Todas', value: 'all' },
                    ...hookSos.data.map((sos) => ({
                        label: sos.description,
                        value: sos.id.toString()
                    }))
                ]}
                onChange={hookForm.handleChange}
            />
        </DrawerComp>
    )
}

export default Filters